import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon, SaveIcon } from 'lucide-react';
export function SupplierForm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const supplierId = searchParams.get('id');
  const isEditing = !!supplierId;
  const [formData, setFormData] = useState({
    companyName: isEditing ? 'Premium Tea Estates Ltd' : '',
    contactPerson: isEditing ? 'Rajesh Kumar' : '',
    email: isEditing ? 'rajesh@premiumtea.lk' : '',
    phone: isEditing ? '+94 77 123 4567' : '',
    address: isEditing ? '123 Tea Estate Road, Nuwara Eliya, Sri Lanka' : '',
    productsSupplied: isEditing ? 'Ceylon Black Tea, Green Tea, White Tea' : '',
    paymentTerms: isEditing ? 'Net 30' : '',
    status: isEditing ? 'Active' : 'Active'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    navigate('/suppliers');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <div className="space-y-6" data-id="element-6056">
      {/* Header */}
      <div className="flex items-center space-x-4" data-id="element-6057">
        <button onClick={() => navigate('/suppliers')} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-6058">
          <ArrowLeftIcon size={20} data-id="element-6059" />
        </button>
        <div data-id="element-6060">
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-6061">
            {isEditing ? 'Edit Supplier' : 'Add New Supplier'}
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-6062">
            {isEditing ? 'Update supplier information' : 'Enter supplier details'}
          </p>
        </div>
      </div>
      {/* Form */}
      <form onSubmit={handleSubmit} data-id="element-6063">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6064">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6065">
            {/* Company Name */}
            <div className="md:col-span-2" data-id="element-6066">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6067">
                Company Name *
              </label>
              <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter company name" data-id="element-6068" />
            </div>
            {/* Contact Person */}
            <div data-id="element-6069">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6070">
                Contact Person *
              </label>
              <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact person name" data-id="element-6071" />
            </div>
            {/* Email */}
            <div data-id="element-6072">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6073">
                Email *
              </label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="email@example.com" data-id="element-6074" />
            </div>
            {/* Phone */}
            <div data-id="element-6075">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6076">
                Phone *
              </label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="+94 XX XXX XXXX" data-id="element-6077" />
            </div>
            {/* Payment Terms */}
            <div data-id="element-6078">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6079">
                Payment Terms
              </label>
              <input type="text" name="paymentTerms" value={formData.paymentTerms} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g., Net 30, Net 60" data-id="element-6080" />
            </div>
            {/* Address */}
            <div className="md:col-span-2" data-id="element-6081">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6082">
                Address
              </label>
              <textarea name="address" value={formData.address} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter full address" data-id="element-6083" />
            </div>
            {/* Products Supplied */}
            <div className="md:col-span-2" data-id="element-6084">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6085">
                Products/Services Supplied
              </label>
              <textarea name="productsSupplied" value={formData.productsSupplied} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="List products or services" data-id="element-6086" />
            </div>
            {/* Status */}
            <div data-id="element-6087">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-6088">
                Status *
              </label>
              <select name="status" value={formData.status} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-6089">
                <option value="Active" data-id="element-6090">Active</option>
                <option value="Inactive" data-id="element-6091">Inactive</option>
              </select>
            </div>
          </div>
          {/* Form Actions */}
          <div className="flex justify-end space-x-3 mt-6 pt-6 border-t border-gray-200" data-id="element-6092">
            <button type="button" onClick={() => navigate('/suppliers')} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" data-id="element-6093">
              Cancel
            </button>
            <button type="submit" className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-6094">
              <SaveIcon size={18} className="mr-2" data-id="element-6095" />
              {isEditing ? 'Update Supplier' : 'Create Supplier'}
            </button>
          </div>
        </div>
      </form>
    </div>;
}